import React from 'react'
import { Link } from 'gatsby'
import { useMediaQuery } from 'react-responsive'
import { FiChevronRight, FiChevronDown } from 'react-icons/fi'
import { Container, AlignCenter } from './styles'

/**
 * Renders a component with related pages for the page set in WP.
 *
 * @component
 *
 * return (
 *  <VejaTambem relatedPages={obj} />
 * );
 */
const VejaTambem = ({ relatedPages = null }) => {
  const notMobile = useMediaQuery({ query: '(min-device-width: 426px)' })

  return (
    <>
      {relatedPages !== null ? (
        <AlignCenter>
          <Container>
            <h3>
              Veja Também
              {notMobile ? <FiChevronRight /> : <FiChevronDown />}
            </h3>

            <ul>
              {relatedPages.map((item, index) => (
                <React.Fragment key={index}>
                  {item.title ? (
                    <li>
                      <Link to={`/${item.slug}`}>{item.title}</Link>
                    </li>
                  ) : (
                    ''
                  )}
                </React.Fragment>
              ))}
            </ul>
          </Container>
        </AlignCenter>
      ) : (
        ''
      )}
    </>
  )
}

export default VejaTambem
